export enum MenuItemType {
  ROUTE = "route",
  ACTION = "action",
}
